import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaUsers,
  FaUsersCog,
  FaUserTie,
  FaUserCircle
} from 'react-icons/fa';
import { MdOutlineWork } from "react-icons/md";
import { DContext } from '../../../context/Datacontext';
import { fetchCardsCount } from '../../services/managerApi/fetchCardCount';
import FloatingLoading from '../../blocks/Layout/Loading';
import { renderCapitalize } from '../../../utils/renderCapitalize';

const cardsConfig = [
  { key: 'clientManagement', title: 'Clients & Spocs', icon: <FaUsersCog size={24} />, route: '/list-clients', color: 'bg-green-100', bg: 'bg-green-300' },
  { key: 'eodReport', title: 'Eod Report', icon: <FaUsersCog size={24} />, route: '/eod-submission-reports', color: 'bg-purple-100', bg: 'bg-purple-300' },
  { key: 'recruitmentReport', title: 'Recruitment Report', icon: <FaUsersCog size={24} />, route: '/recruitment', color: 'bg-blue-100', bg: 'bg-blue-300' },

  { key: 'JobManagement', title: 'Job Management', icon: <MdOutlineWork size={24} />, route: '/list-jobs', color: 'bg-red-100', bg: 'bg-red-300' },

];

export default function AdminsDashboard() {
  const navigate = useNavigate();
  const { BeURL, showAlert, currentUser } = useContext(DContext);
  const [counts, setCounts] = useState({});

  useEffect(() => {
    if (currentUser && BeURL) {
      const companyId = currentUser.companyId ? currentUser.companyId : currentUser.company.companyId
      fetchCardsCount(BeURL, showAlert, companyId, setCounts)
    }
  }, [BeURL, currentUser]);

  if (!BeURL || !currentUser) return <div className='min-h-[80vh]'><FloatingLoading /></div>

  return (
    <div className="min-h-[80vh] p-6">

      <h2 className="text-center text-2xl font-semibold text-primary-600 mb-8">
        Recruiter Dashboard
      </h2>

      <div className=' flex justify-end mb-5 px-16'>

        {/* <button className='rounded-full px-4 py-1 text-md bg-secondary-500 hover:bg-secondary-600 text-white' onClick={() => navigate('/create-users')}>Create HelpDesk</button> */}

      </div>
      <div
        className="flex flex-wrap justify-center items-stretch gap-6"
        style={{ alignContent: 'center' }}
      >
        {cardsConfig.map(card => (
          <div
            key={card.key}
            onClick={() => navigate(card.route)}
            className={`${card.color} w-full sm:w-[48%] lg:w-[22%] rounded-2xl shadow-lg hover:shadow-xl transition p-6 cursor-pointer text-center`}
          >
            <div className={`p-4 rounded-full text-slate-800 w-fit mx-auto ${card.bg}`}>
              {card.icon}
            </div>
            <h3 className="text-3xl font-bold text-slate-700 my-2">
              {['recruitmentReport','eodReport'].includes(card.key) ? '1'  : counts[card.key] ?? '--'}
            </h3>
            <p className="text-slate-900 mt-2 text-lg font-medium">
              {renderCapitalize(card.title)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
